import { react } from "uikit";
import { Dispatch } from "react";

import { PaymentCountryIso } from "../../../../../../../../services/PaymentSystem";

import CybersourcePaymentsCountryIso from ".";

interface Context {
	value: CybersourcePaymentsCountryIso.Value;
	setError: Dispatch<boolean>;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isValid =
			this.context?.value.cybersourceCountryIso !==
			PaymentCountryIso.NULL;

		if (!isValid) {
			this.context?.setError(true);
			return isValid;
		}
		this.context?.setError(false);
		return isValid;
	}
}
